import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Route } from "react-router-dom";
import { withRouter } from "react-router";
import { push } from "connected-react-router";
import { useTranslation } from "react-i18next";
import AdminPageLayout from "../../components/FullPageLayout/AdminPageLayout";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import {
  administrationSpecialAssignments,
  buildSpecialAssignmentSettingsRoute,
  buildManageSpecialAssignmentRoute
} from "../../routes/AdminRoutes";
import Tabs from "../../components/Tabs/Tabs";
import SettingsForm from "./SettingsForm";
import AssignEmployeesForm from "./AssignEmployeesForm";
import { useSpecialAssignments } from "../../hooks/assignments";

const ManageSpecialAssignmentContainer = props => {
  const { specialAssignmentId } = useParams();
  const [currentTab, setCurrentTab] = useState(0);
  const {
    getSpecialAssignment,
    deleteSpecialAssignment
  } = useSpecialAssignments();
  const [currentAssignment, setCurrentAssignment] = useState(null);
  const [hasAssignedEmployees, setHasAssignedEmployees] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { history, location } = props;
  const tabs = [
    {
      title: t("specialAssignments.tabs.settings"),
      path: buildSpecialAssignmentSettingsRoute(specialAssignmentId)
    },
    {
      title: t("specialAssignments.tabs.assinEmployees"),
      path: buildManageSpecialAssignmentRoute(specialAssignmentId)
    }
  ];

  useEffect(() => {
    getSpecialAssignment(specialAssignmentId).then(data => {
      setCurrentAssignment(data);
      setHasAssignedEmployees(!!data.assignedCount);
    });
  }, []);

  useEffect(() => {
    const currentPathIndex = tabs.findIndex(
      tab => tab.path === location.pathname
    );
    if (currentPathIndex !== -1) {
      setCurrentTab(currentPathIndex);
    }
  }, [location]);

  const handleTabChange = newTab => {
    setCurrentTab(newTab);
    history.push(tabs[newTab].path);
  };

  useEffect(() => {
    setCurrentTab(
      tabs.findIndex(({ path }) => path === history.location.pathname)
    );
  }, []);

  const handleGoBack = () => {
    dispatch(push(administrationSpecialAssignments));
  };

  const handleDeleteSpecialAssignment = specialAssignmentId => {
    deleteSpecialAssignment(specialAssignmentId).then(() => {
      handleGoBack();
    });
  };

  return (
    <AdminPageLayout
      title={
        <Breadcrumb
          routes={[
            t("specialAssignments.title"),
            currentAssignment ? currentAssignment.name : ""
          ]}
        />
      }
      onGoBackClick={handleGoBack}
    >
      <Tabs
        tabs={tabs.map(({ title }) => title)}
        currentTab={currentTab}
        onChange={newTab => handleTabChange(newTab)}
        scrollButtons={false}
        textVariant="h6"
      />
      <Route
        exact
        path={buildSpecialAssignmentSettingsRoute(specialAssignmentId)}
        render={props => {
          return (
            <SettingsForm
              specialAssignmentId={specialAssignmentId}
              existingAssignment={currentAssignment}
              hasAssignedEmployees={hasAssignedEmployees}
              goBack={handleGoBack}
              onDeleteAssignment={handleDeleteSpecialAssignment}
            />
          );
        }}
      />
      <Route
        exact
        path={buildManageSpecialAssignmentRoute(specialAssignmentId)}
        render={props => {
          return (
            <AssignEmployeesForm
              existingAssignmentId={specialAssignmentId}
              onGoBack={handleGoBack}
              setHasAssignedEmployees={setHasAssignedEmployees}
            />
          );
        }}
      />
    </AdminPageLayout>
  );
};

export default withRouter(ManageSpecialAssignmentContainer);
